import React from "react";
import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary, Grid } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { FormField } from "../../../../../Form/FormField";

const SeriesAccordion: React.FC = () => {
  return (
    <SectionWrapper>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Series
        </AccordionSummary>
        <AssetAccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormField
                name="seriesId"
                label="Series ID"
                placeholder="Series ID..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="seasonId"
                label="Season ID"
                placeholder="Season ID..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="seasonNumber"
                label="Season Number"
                placeholder="Season number..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="episodeNumber"
                label="Episode number"
                placeholder="Episode number..."
              />
            </Grid>
          </Grid>
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default SeriesAccordion;
